export default __webpack_public_path__ + "static/media/low-rating.97e106a8.png";